export type Counterpart = {
    id: string;
    companyName: string;
    organizationNo: string;
    address: string;
    zipCode: string;
    city: string;
    country: string;
    fullname: string;
    title: string;
    phone: string;
    email: string;
    linkedin: string;
    website: string;
    numberOfAgreements: number;
    created: string;
    createdBy: string;
    isDeletable: boolean;
    hasEsgReport: boolean;
};
